import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

// Map browser locale to supported language codes
const SUPPORTED = ['pt-BR', 'es', 'en', 'fr', 'de', 'it', 'ja'];

function resolveLanguage(): string {
  // 1. If user already manually selected, use that
  const saved = localStorage.getItem('i18n_lang');
  if (saved && SUPPORTED.includes(saved)) return saved;

  // 2. Detect from browser navigator
  const browserLangs = navigator.languages ?? [navigator.language];
  for (const lang of browserLangs) {
    // Exact match first (e.g. 'pt-BR')
    if (SUPPORTED.includes(lang)) return lang;
    // Prefix match (e.g. 'pt' → 'pt-BR', 'de-AT' → 'de')
    const prefix = lang.split('-')[0];
    const match = SUPPORTED.find((s) => s === prefix || s.startsWith(prefix + '-'));
    if (match) return match;
  }

  // 3. Default fallback
  return 'pt-BR';
}

const resolvedLang = resolveLanguage();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: resolvedLang,
    fallbackLng: 'pt-BR',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // We handle detection manually above, disable auto-detection
      order: [],
    },
  });

export default i18n;
